import { CircularProgress } from '@mui/material';
import { styled } from '@mui/material/styles';

const PeekCircularProgress = styled(CircularProgress)(({ theme }) => ({}));

export { PeekCircularProgress, PeekCircularProgress as default };
